/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import { Select, Form } from "antd";
// import { Option } from "antd/lib/mentions";
import React from "react";
import { useSelector } from "react-redux";

const DokanSelectField = ({ mode, placeholder = "Select" , FormInputName, FormInputLabel, FormInputRules, data, onValueChange}) => {
  const handleChange = () => {};
  const items = [
      {value:'in-stock', name: 'In Stock'},
      {value:'stock-out', name: 'Stock Out'},
      {value:'upcoming', name: 'Upcoming'}
  ];
  // Handle Select....
  const changeInputField = (name, value) => {
    // console.log('select', name, value);
    onValueChange(name, value);
};

const getInputData = useSelector((state) => state.products.productInputData);
const InputData = { ...getInputData };
const setInputData = InputData[FormInputName];
const options = items.map(d => <Select.Option key={d.value}>{d.name}</Select.Option>);

  return (
    <>
    <Form.Item name={FormInputName} label={FormInputLabel} rules={FormInputRules}>
    <Select
      mode={mode}
      className="mt-20px dokan-select"
      showArrow
      style={{ width: "100%" }}
      onChange={(value) => changeInputField(FormInputName, value)}
      placeholder={placeholder}
      value={setInputData}
    >
      {options}
    </Select>
    </Form.Item>
    </>
  );
};

export default DokanSelectField;
